import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 8H8v4H4v2h4v4h2v-4h4v-2h-4zm4.5-1.92V7.9l2.5-.5V18h2V5z"
}), 'PlusOne');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PlusOne.js
// module id = 5537
// module chunks = 2